import { useMutation, useQueryClient } from "react-query";
import { crearCarpeta, updateCarpeta, deleteCarpeta} from '../../services/Carpetas';
import { toast } from 'react-hot-toast';

const queryKey = "carpetas";

export const useCarpetasMutations = () => {
  const queryClient = useQueryClient();
  const onError = (err = null) => {
    if (err.statusCode === 409) {
      return toast.error(`El valor ${err.duplicateValue} ya se encuentra registrado`);
    }
    toast.error('Error consulte con Soporte!');
  };

  const onSuccess = () => {
    toast.success('Datos Guardados Exitosamente!');
    queryClient.invalidateQueries(queryKey);
  };
  const addCarpeta = useMutation((body) => crearCarpeta(body), {
    onSuccess,
    onError: (err) => onError(err),
  });
 
  const updateCarpetaC = useMutation(
    (body) => updateCarpeta( body),
    {
      onSuccess,
      onError: (err) => onError(err),
    }
  );
  const removeCarpeta = useMutation((id) => deleteCarpeta( id), {
    onSuccess,
    onError,
  });

  return { addCarpeta, updateCarpetaC, removeCarpeta };
};
export default useCarpetasMutations;